import InsuranceForm from './InsuranceForm'
export default InsuranceForm
